import React, { useEffect, useState } from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import PropertyList from '../Components/Properties/PropertyList'
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore'
import { db } from '../firebase.config'

const Properties = () => {
  const [properties, setProperties] = useState([])
  const fetchProperties = async () =>{
    const querySnapshot = await getDocs(collection(db, "properties"));
    querySnapshot.forEach((doc) => {
     setProperties((prev)=>[...prev,{
      id:doc.id,
      ...doc.data()
     }])
   
  
    });
  }
  const deleteProperty = async (id) =>{
     await deleteDoc(doc(db, "properties", id))
    window.location.reload()
  
  }
  useEffect(() => {
   fetchProperties()
  }, [])
  
  return (
    <div className='bg-gray-200 h-[100vh]' >
    <MultiLevelSidebar />
    <PropertyList deleteProperty={deleteProperty} properties={properties} />
  </div>
  )
}

export default Properties